const BASE_TEST_URL = "https://appt.iprpraha.cz/apl-dev/_src/"
const BASE_PROD_URL = "https://app.iprpraha.cz/apl/_src/"

function getBaseUrl() {
    const mode = import.meta.env.MODE
    console.log("MODE: " + mode)
    return mode === "production" ? BASE_PROD_URL : BASE_TEST_URL
}

function getSourcesPath() {
    return getBaseUrl() + "sources.json"
}

function getTokensPath() {
    return "https://geoportalpraha.cz/backend/get-tokens/"
}

export function usePaths() {
    return {
        getSourcesPath,
        getTokensPath,
    }
}
